import React from "react";
import { Col, Form, Input, Row, Select } from "antd";
const { Option } = Select;

export function BankInformation({ getFieldDecorator, bank, fixedList, iban, nib }) {
    return (
        <Form layout="vertical">
            <Row gutter={16}>
                <Col xs={24} md={8} offset={8}>
                    <Form.Item label="Banco">
                        {getFieldDecorator("bank", {
                            initialValue: bank,
                        })(
                            <Select
                                showSearch
                                allowClear
                                style={{ width: "100%" }}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {fixedList.bancos !== undefined &&
                                    fixedList.bancos.data.map((item) => {
                                        return (
                                            <Option key={item.id_banco} value={item.id_banco}>
                                                {item.nome}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        )}
                    </Form.Item>
                </Col>
                <Col xs={24} md={8} offset={8}>
                    <Form.Item label="IBAN">
                        {getFieldDecorator("iban", {
                            initialValue: iban,
                        })(<Input />)}
                    </Form.Item>
                </Col>
                <Col xs={24} md={8} offset={8}>
                    <Form.Item label="NIB">
                        {getFieldDecorator("nib", {
                            initialValue: nib,
                        })(<Input placeholder="NIB" />)}
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
}
